export default "__VITE_ASSET__BL1FjJzQ__"